// SPDX-License-Identifier: MIT
import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (!url || !key) {
  throw new Error('VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set (see .env.local)');
}

export const supabase = createClient(url, key, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Force implicit (hash) flow for email magic-link. supabase-js v2.46+
    // defaults to PKCE for OAuth providers, but for email magic-link the
    // signInWithOtp call sends `code_challenge: null` regardless — server
    // then redirects with hash params (#access_token=...) instead of PKCE
    // (?code=...). With flowType unspecified or 'pkce', the client's
    // _detectSessionFromUrl() looks ONLY for ?code= and silently ignores
    // the hash → getSession() returns null at /auth/callback → handler
    // redirects to /?auth=expired despite a valid session in URL hash.
    // iter-4 fix (post v1.0.0 Genesis cutover) for the consistent
    // "lien expiré" symptom on freshly-clicked magic-links.
    flowType: 'implicit',
  },
});
